import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WorkOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"work_off"}/>
}
